import { useEffect, FC as ReactFC } from 'react';

const ScrollToTopOnMount: ReactFC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return null;
};

export default ScrollToTopOnMount;
